var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00CEBC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.5 15.75h15m-15-2.25h15M4.853 2.25c.346.275.564.677.564 1.125 0 .828-.747 1.5-1.667 1.5-.498 0-.944-.196-1.25-.508M4.853 2.25h10.294m-10.294 0c-.73.002-1.129.02-1.443.163a1.6 1.6 0 0 0-.728.656c-.16.283-.18.642-.182 1.298m0 0v4.766M15.147 2.25a1.44 1.44 0 0 0-.564 1.125c0 .828.746 1.5 1.667 1.5.498 0 .944-.196 1.25-.508M15.147 2.25c.73.002 1.129.02 1.443.163s.569.374.728.656.18.642.182 1.298m-15 4.766a1.75 1.75 0 0 1 1.25-.508c.92 0 1.667.672 1.667 1.5 0 .448-.218.85-.564 1.125M2.5 9.133c.003.656.022 1.015.182 1.298.16.282.414.512.728.656s.714.16 1.443.163m0 0h10.294m0 0a1.44 1.44 0 0 1-.564-1.125c0-.828.746-1.5 1.667-1.5.498 0 .945.196 1.25.508m-2.353 2.117c.73-.002 1.129-.02 1.443-.164.314-.143.569-.373.728-.655s.18-.642.182-1.298m0 0V4.367M11.667 6.75c0 .828-.746 1.5-1.667 1.5-.92 0-1.667-.672-1.667-1.5S9.08 5.25 10 5.25c.92 0 1.667.672 1.667 1.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyGreen);
export default __webpack_public_path__ + "static/media/moneyGreen.68c2df2bf9f69b25453809c01e2b8661.svg";
export { ForwardRef as ReactComponent };